import { React, useState, useEffect } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import { Button, Row, Col, Form, PageHeader, Radio } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { useNavigate, useLocation } from "react-router-dom";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import { lengthUnit, weightUnit } from "../../../Utils/Constant/MeasurementUnitList";
const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const exportJRData = [
  { label: "CSV", value: "CSV" },
  { label: "PDF", value: "PDF" },
];

const headers = [
  { label: "JUMBO ROLL NO.", key: "number" },
  { label: "CREATED DATE", key: "created_date" },
  { label: "MACHINE CODE", key: "machineCode" },
  { label: "WIDTH(CM)", key: "width" },
  { label: "PRODUCT CODE", key: "productCode" },
  { label: "PRODUCT NAME", key:"productName"},
  { label: "GRADE", key: "grade" },
  { label: "GSM", key: "gsm" },
  { label: "BF", key: "bf" },
  { label: "QUALITY", key: "quality" },
  { label: "WEIGHT", key: "weight" },
  { label: "PRODUCTION DATE", key: "production_date" },
  { label: "SHIFT", key: "shift" },
  { label: "% UTILIZED", key: "utilized" },
  { label: "STATUS", key: "status" },
];
const headersForMappingDetails = [
  { label: "PARENT REEL/SET NUMBER", key: "parentReelNo" },
  { label: "JOB CARD NUMBER", key: "jc_code" },
  { label: "JOB CARD STATE", key: "jobCardState" },
  { label: "FINISHING DATE", key: "finishingDate" },
  { label: "SIZE", key: "size" },
  { label: "REEL OD", key:"reelOD"},
  { label: "CORE OD", key: "coreOD" },
  { label: "WEIGHT", key: "weight" },
  { label: "NUMBER OF CHILD REELS/SHEETS", key: "noOfChildReels" },
  { label: "MATCH TRIM", key: "matchTrim" },
  { label: "NET TRIM", key: "netTrim" },
  { label: "PARENT REEL STATUS", key: "parentReelStatus" },
];

const ExportJumboReels = (props) => {
  const [exportType, setExportType] = useState(exportJRData[1].value);
  const [exportData, setExportData] = useState();
  const location = useLocation();
  const [parentRecords, setParentRecords] = useState(location.state?.jumboRecords);
  const [pageKey, setMappingDetailsKey] = useState(location.state?.pageKey);
  const [returnKey, setReturnKey] = useState(location.state?.returnKey ? location.state.returnKey : false);
  const [fileName, setFileName] = useState(location.state?.fileName ? location.state?.fileName : "Jumbo_roll_records");
  const [dataForPdf, setDataForPdf] = useState();
  const [jumboRecords, setJumboRecords] = useState([]);
  const history = useNavigate();
  useEffect(() => {
    fetchJumboRecords();
  }, []);

  const fetchJumboRecords = () => {
    let exportDataJson = {};
    let  formattedList = [];
    if(returnKey){
      setExportData(parentRecords);
    } else{
    parentRecords?.map((item) => {
      exportDataJson = {};
       exportDataJson["number"] = item.number ? item.number : "";
       exportDataJson["created_date"] = item.created_date ? item.created_date : "";
       exportDataJson["machineCode"] = item.machine ? item.machine: "";
       exportDataJson["width"] = item.width ? (item.width + " " + (item.units? lengthUnit[item.units.width]?.displayName?.toUpperCase() : "CM")): "";      
       exportDataJson["productCode"] = item.code? item.code : "";
       exportDataJson["productName"] = item.name ? item.name : "";
       exportDataJson["grade"] = item.grade ? item.grade : "";
       exportDataJson["gsm"] = item.gsm ? item.gsm : "";
       exportDataJson["bf"] = item.bf ? item.bf : "";
       exportDataJson["quality"] = item.quality ? item.quality: "";
       exportDataJson["weight"] = item.weight ? (parseFloat(item.weight).toFixed(3) + " " + (item.units? capitalize(weightUnit[item.units.weight]?.displayName) : "T")) : "";
       exportDataJson["production_date"] = item.production_date ? item.production_date : "";
       exportDataJson["shift"] = item.shift ? item.shift : "";
       exportDataJson["utilized"] = item.utilized ? parseFloat(item.utilized).toFixed(3) : "";
       exportDataJson["status"] = item.status ? item.status : "";
       exportDataJson["product_spec"] =  item.product_spec ? item.product_spec : "";
       exportDataJson["parentReelNo"] = item.parentReelNo ? item.parentReelNo : "";
       exportDataJson["jobCardNo"] = item.jobCardNo ? item.jobCardNo : "";
       exportDataJson["jc_code"] = item.jc_code ? item.jc_code : "";
       exportDataJson["jobCardState"] = item.jobCardState ? item.jobCardState : "";
       exportDataJson["rewinding_date"] = item.rewinding_date ? item.rewinding_date : "";
       exportDataJson["cutting_date"] = item.cutting_date ? item.cutting_date : "";
       exportDataJson["size"] = item.size ? (item.size + " " + ((item.units && item.units.size) ? lengthUnit[item.units.size]?.displayName?.toUpperCase() : "CM")) : "";
       exportDataJson["reelOD"] = item.reel_od? (item.reel_od + " " + (item.reel_od !== "-" ? (item.units? lengthUnit[item.units.reel_od]?.displayName?.toUpperCase() : "CM") : "" )) : "";
       exportDataJson["coreOD"] = item.core_id ? (item.core_id + " " + (item.reel_od !== "-" ? (item.units? lengthUnit[item.units.core_id]?.displayName?.toUpperCase() : "CM") : "" )) : "";
       exportDataJson["noOfChildReels"] = item.noOfChildReels ? item.noOfChildReels : "";
       exportDataJson["matchTrim"] = item.matchTrim ? (item.matchTrim + " " + (item.units? lengthUnit[item.units.trim_loss]?.displayName?.toUpperCase() : "CM")): "";
       exportDataJson["netTrim"] = item.netTrim ? (item.netTrim + " " + (item.units? lengthUnit[item.units.net_trim_loss]?.displayName?.toUpperCase() : "CM")) : "";
       exportDataJson["parentReelStatus"] = item.parentReelStatus ? item.parentReelStatus : "";
       exportDataJson["finishingDate"] = `${(item.rewinding_date ? moment(item.rewinding_date).format("DD MMM YYYY") : "")+ " " + 
       (item.cutting_date ? moment(item.cutting_date).format("DD MMM YYYY") : "")}`
       formattedList.push(exportDataJson);  
    });
    setExportData(formattedList);
    }
 };

  const exportStatusChange = (e) => {
    setExportType(e.target.value);
  };
  const exportHandler = async() => {
    if (exportType === "PDF") {
      history("../jumbo-reel-records/exportPdf", {
        state: { 
          pdfData: exportData,
          pageKey: pageKey,
          searchKey: location.state?.searchKey,
          fileNameForPDF: fileName,
        },
      });
    }
    else{
      try{
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Jumbo Reels Records');

        const headers_data = pageKey=="Jumbo Reels Records" ? headers : headersForMappingDetails;

        worksheet.columns = headers_data.map((header)=>({
          header: header.label,
          key: header.key,
        }))

        const headRow = worksheet.getRow(1);

        headRow.eachCell((cell)=>{
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "f3f4f6"
            }
          }
          cell.font = {
            bold: true,
          }
        })

        exportData?.forEach((record)=>{
          const row = worksheet.addRow(record);
        })

        worksheet.columns.forEach((column)=>{
          let maxLength = 10;
          column.eachCell((cell)=>{
            let value = cell?.value?.toString() || "";
            maxLength = Math.max(maxLength,value?.length);
          })
          column.width = maxLength>50?50:maxLength+2;
        })

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]),`${fileName}.xlsx`)
      }
      catch(e)
      {
        console.log(e);
      }
    }
  };
  return (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() => history("../jumbo-reel-records")}
          title="Export jumbo reel records"
          extra={[
            <Button
              key="1"
              className="themeBtn noBg"
              onClick={() => history("../jumbo-reel-records")}
            >
              <Iconmoon icon="wrong" size={14} color="#EA655B" />
              Cancel
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form name="basic" autoComplete="off" className="haberLogin">
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Select Options</h2>
                    <p>
                      Here you can select options to customize data that will be
                      downloaded
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Data Format</label>
                        <p>Select a format to download data</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Radio.Group
                          options={exportJRData}
                          onChange={exportStatusChange}
                          value={exportType}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="buttonRight" style={{ marginTop: "20px" }}>
                <Form.Item>
                { (exportType === "PDF") ? 
                  ( pageKey=="Jumbo Reels Records" ) ? (
                    <Button
                      onClick={() => exportHandler()}
                      className="themeBtn"
                    >
                      Preview &#38; Download Jumbo Reel Records
                    </Button>
                  ) : (
                    <Button
                    onClick={() => exportHandler()}
                    className="themeBtn"
                  >
                    Preview &#38; Download Jumbo Roll Mapping Records
                  </Button>
                  )
                 : (
                  <Button
                      onClick={() => exportHandler()}
                      className="themeBtn csv"
                    >
                    {pageKey=="Jumbo Reels Records" 
                       ? "Download Jumbo Reel Records"
                       : "Download Jumbo Roll Mapping Records"
                    }
                    </Button>
                 )
                }
                </Form.Item>
              </div>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
    </RightLayoutContainer>
  );
};

export default ExportJumboReels;
